import { render, staticRenderFns } from "./relateStar.vue?vue&type=template&id=3512c5c4&"
import script from "./relateStar.vue?vue&type=script&lang=ts&"
export * from "./relateStar.vue?vue&type=script&lang=ts&"
import style0 from "./relateStar.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports